import { Base } from "@/atoms-react/text/Text.react";
import { ShieldCheckIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";

type MiniShieldIconProps = {
  level: number;
  className?: string;
};

export const MiniShieldIcon = (props: MiniShieldIconProps) => {
  const { level, className } = props;

  let color: string;
  switch (level) {
    case 0:
      color = "#D10108";
      break;
    case 1:
      color = "#D10108";
      break;
    case 2:
      color = "#3181FB";
      break;
    case 3:
      color = "#62CB13";
      break;
    case 4:
      color = "#723513";
      break;
    case 5:
      color = "#757575";
      break;
    case 6:
      color = "#C99633";
      break;
    default:
      color = "#D10108";
      break;
  }

  return (
    <div
      className={twMerge(
        "flex w-16 items-center justify-between rounded-sm py-1 pr-3 pl-1",
        className
      )}
      style={{ backgroundColor: color }}
    >
      <ShieldCheckIcon className="h-6 w-8 text-white" />
      <Base className="text-white">{level}</Base>
    </div>
  );
};
